import projectService from 'services/project.service';
import { FACILITIES_PROJECTS_ACTIONS as ACTIONS } from 'features/facilities/projects/facilitiesProjects.constants';

export const onLoad = (facilityId) => (dispatch) => {
  dispatch({
    type: ACTIONS.FACILITIES_PROJECTS_PAGE_LOADED,
    payload: () => Promise.all([projectService.searchProjects({ facilityId })]),
  });
};
